import { render, staticRenderFns } from "./ColumnLastUpdate.vue?vue&type=template&id=55a93ea8&"
import script from "./ColumnLastUpdate.vue?vue&type=script&lang=ts&"
export * from "./ColumnLastUpdate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports